import React from 'react';
import Button from './../button/./button';
// @ts-ignore
import {MobileBreakpoint} from './../../themes/kent/utilities/constants';

/**
 *
 * Text Over Image Thumb With Button component
 * @extends {React.Component}
 */
interface IProps {
  title?: string;
  subTitle?: string;
  image?: any;
  mobileImage?: any;
  verticalPosition?: string;
  horizontalPosition?: string;
  link?:string;
  buttonText?:string;
  tint?:string;
  height?:string;
}

class Banner extends React.Component<IProps>{
  public render(): JSX.Element {
    let verticalPositionClass = this.props.verticalPosition ?  "vertical-"+this.props.verticalPosition : "vertical-center";
    let horizontalPositionClass = this.props.horizontalPosition ?  "horizontal-"+this.props.horizontalPosition : "horizontal-center";
    let backgroundTintClass = this.props.tint;
    let heightClass= this.props.height ? this.props.height+"-height" : 'half-height';
    let image = this.props.image;
    if(this.props.mobileImage && window.innerWidth < MobileBreakpoint){
      image = this.props.mobileImage;
    }
    let item =
    <div className={"banner full-width "+verticalPositionClass+" "+horizontalPositionClass+" "+heightClass}>
      <div className="banner-contents">
        {this.props.title && <div className="banner-title h3">{this.props.title}</div>}
        {this.props.subTitle && <div className="banner-subtitle h5">{this.props.subTitle}</div>}
        {this.props.buttonText && <div className="banner-button">
          <Button text={this.props.buttonText} backgroundColor={'#fff'} color={'#000'} />
        </div>}
      </div>
      {this.props.tint && <div className={"tint "+backgroundTintClass}></div>}
      {image && <div className="banner-background" style={{backgroundImage:"url("+image+")"}}></div>}
    </div>
    if(this.props.link){
      return <a href={this.props.link} style={{width:'100%'}}>{item}</a>
    } else{
      return item
    }
  }
}

 export default Banner;
